import {
    FETCH_REQUEST, FetchRequestAction
} from '../../../../../middleware';
import { getConfigGatewayUrl } from '../../../../state';
import { transformAppInit } from '../../../../state/effects-middleware/utils/app-fetch-configuration';
import { FETCH_DUCS_CONTENT } from './ducs-modal.reducer';
import { DucsData } from './ducs-modal.types';

export const fetchDucsContent = (girlId: string): FetchRequestAction<DucsData> => ({
    type: FETCH_REQUEST,
    payload: {
        name: FETCH_DUCS_CONTENT,
        resolveUrl: getConfigGatewayUrl({
            key: 'DUCSContentGatewayEndpoint',
            basePath: `resources/${girlId}`
        }),
        body: null,
        method: 'GET',
        transformInit: transformAppInit
    }
});

